import React from 'react';
import './MapCharacter.css';

function MapCharacter({ position, avatar, isMoving }) {
    return (
        <div
            className={`map-character ${isMoving ? 'moving' : ''}`}
            style={{
                left: position.x,
                top: position.y
            }}
        >
            {/* Character shadow */}
            <div className="character-shadow" />

            {/* Character body */}
            <div className="character-body">
                <span className="character-avatar">{avatar}</span>
            </div>

            {/* Movement trail effect */}
            {isMoving && (
                <div className="movement-trail">
                    <span className="trail-particle">✨</span>
                    <span className="trail-particle">✨</span>
                    <span className="trail-particle">✨</span>
                </div>
            )}

            {/* Standing idle animation particles */}
            {!isMoving && (
                <div className="idle-particles">
                    <span className="idle-particle">⭐</span>
                </div>
            )}
        </div>
    );
}

export default MapCharacter;
